import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as CarModels from "../../../../../../src/app/models/car/car";
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";


@Component({
    selector: 'app-car-details',
  templateUrl: './car-details.component.html',
  styleUrls: ['./car-details.component.css']
})

export class CarDetailsComponent extends AldFormBaseComponent implements OnInit {


  private requestCarSave: Models.Request<CarModels.CarModel> = new Models.Request<CarModels.CarModel>();

  public requestGetCar: Models.RequestModel = null;

  public car: CarModels.CarModel;
  public formMain: FormGroup;
  public IsEmailValid: boolean = false;
  public IsTelephoneValid: boolean = false;

  @Select(AldState.Car)
  Car$: Observable<Models.Response<CarModels.CarModel>>;




  get inputFirstName(): any {
    return this.formMain.get('inputFirstName');
  }

  get inputLastName(): any {
    return this.formMain.get('inputLastName');
  }

  get inputPhoneNr(): any {
    return this.formMain.get('inputPhoneNr');
  }

  get inputMail(): any {
    return this.formMain.get('inputMail');
  }

    constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef
    ) {

      super(helperService, environmentService, changeDetectorRef, router, authenticationService, store);
    }

  ngOnInit() {

    super.ngOnInit();

    this.formMain = this.formBuilder.group({
      inputFirstName: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(3)]],
      inputLastName : ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      inputPhoneNr  : ['', Validators.required],
      inputMail     : ['', Validators.required]
        });

    this.subscription.add(this.Car$.subscribe((data) => {
      if (data && data.Success && data.Item.CarId == this.currentUser.CarId) {
        this.car = data.Item;

        if (data.RequestSignature == this.requestCarSave.RequestSignature) {
          this.onHome();
        }
      }

      }));
    }


    onSubmit() {

        // stop here if form is invalid
      if (!this.IsFormValid()) {
            return;
        }

      this.requestCarSave.Item = this.car;

      this.requestCarSave.Begin();

      this.store.dispatch(new AldActions.CarSet(this.requestCarSave));

      this.car = null;
  }

  public onValidationEmail(error: boolean) {

    this.IsEmailValid = !error;
  }

  public onValidationTelephone(error: boolean) {

    this.IsTelephoneValid = !error;
  }

  public IsFormValid(): boolean {
    return this.IsEmailValid && this.IsTelephoneValid && this.formMain.valid;
  }

  public onUserAuthenitcate() {
    if (this.currentUser && this.currentUser.CarId) {

      this.requestGetCar = new Models.RequestModel(this.currentUser.CarId);

      this.store.dispatch(new AldActions.CarGet(this.requestGetCar));
    }
  };

  public onSummary() { }
}
